export const useAWSClient = () => {
  return {
    put: async <T>(endpoint: string, file: File): Promise<T | null> => {
      const url = `${endpoint}`;

      try {
        const response = await fetch(url, {
          method: 'PUT',
          body: file,
        });

        if (!response.ok) {
          const errorData = await response.json().catch(() => null);
          throw new Error(
            `API error: ${response.status} - ${errorData?.message || response.statusText}`
          );
        }
        const textData = await response.text();
        return textData ? JSON.parse(textData) : null;
      } catch (error) {
        console.error('API request failed:', error);
        throw error;
      }
    },
  };
};
